function recommendation(backendAxiosInstance) {
  async function addToMyList(addToMyListParams) {
    return backendAxiosInstance.post("/experiences/v4/recommendation/mylist", addToMyListParams);
  }
  return {
    addToMyList
  };
}

export { recommendation as default };
//# sourceMappingURL=recommendation.js.map
